import React, { useState, useRef, useEffect } from "react";
import "./BookingMenu.css";

export default function BookingMenu({ label, options }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!options || options.length === 0) return null;

  return (
    <div className="beef-booking" ref={ref}>
      <button
        type="button"
        className="beef-btn beef-booking__trigger"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        {label}
      </button>

      {open ? (
        <div className="beef-booking__menu" role="menu">
          {options.map((opt) => (
            <a
              key={opt.label + opt.href}
              role="menuitem"
              className="beef-booking__item"
              href={opt.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
            >
              {opt.label}
            </a>
          ))}
        </div>
      ) : null}
    </div>
  );
}
